import index from "./Quickbook";
export default index;